// These photographed nail silhouettes should have continuous convex sides.
// Their pixel traces contain small extraction dents: keep each trace's outer
// contour, smooth its joins in source-pixel space, then restore its own bounds.
// This preserves the 72 different profiles without changing photograph pixels
// or the positions of art layers.
const cache=new Map();
const distance=(a,b)=>Math.hypot(a[0]-b[0],a[1]-b[1]);
function cleanOutline(points){
 const sorted=[...points].sort((a,b)=>a[0]-b[0]||a[1]-b[1]),turn=(a,b,c)=>(b[0]-a[0])*(c[1]-a[1])-(b[1]-a[1])*(c[0]-a[0]);
 const side=values=>{const result=[];for(const point of values){while(result.length>1&&turn(result.at(-2),result.at(-1),point)<=0)result.pop();result.push(point);}return result;};
 return [...side(sorted).slice(0,-1),...side(sorted.reverse()).slice(0,-1)];
}
export function smoothNailContour(path,width,height) {
 if(typeof path!=='string'||!Number.isFinite(width)||!Number.isFinite(height)||width<=0||height<=0||/[^MLZ0-9.,\s-]/.test(path))return path;
 const key=`${width}:${height}:${path}`;if(cache.has(key))return cache.get(key);
 const coordinates=path.match(/-?\d+(?:\.\d+)?/g)?.map(Number)||[];
 if(coordinates.length<8||coordinates.length%2)return path;
 let points=[];for(let i=0;i<coordinates.length;i+=2)points.push([coordinates[i]*width/100,coordinates[i+1]*height/150]);
 if(distance(points[0],points.at(-1))<.001)points.pop();
 points=cleanOutline(points);
 const sampled=[];
 let residual=0;
 for(let index=0;index<points.length;index++){
  const point=points[index],end=points[(index+1)%points.length],length=distance(point,end);
  for(;residual<length;residual+=1.8)sampled.push(point.map((value,axis)=>value+(end[axis]-value)*residual/length));
  residual-=length;
 }
 if(sampled.length<4)return path;
 const weights=[1,4,6,4,1],outline=sampled.map((point,index)=>point.map((_,axis)=>weights.reduce((sum,weight,offset)=>sum+weight*sampled[(index+offset-2+sampled.length)%sampled.length][axis],0)/16));
 // Preserve each photographed shape's own overall width, height and placement.
 for(const axis of [0,1]){const originalMin=Math.min(...points.map(p=>p[axis])),originalMax=Math.max(...points.map(p=>p[axis])),min=Math.min(...outline.map(p=>p[axis])),max=Math.max(...outline.map(p=>p[axis]));if(max===min)return path;for(const point of outline)point[axis]=originalMin+(point[axis]-min)*(originalMax-originalMin)/(max-min);}
 const midpoint=(a,b)=>a.map((value,index)=>(value+b[index])/2);
 const format=point=>`${+(point[0]*100/width).toFixed(4)} ${+(point[1]*150/height).toFixed(4)}`;
 const result=`M${format(midpoint(outline.at(-1),outline[0]))}`+outline.map((point,index)=>`Q${format(point)} ${format(midpoint(point,outline[(index+1)%outline.length]))}`).join('')+'Z';
 cache.set(key,result);return result;
}
